import { render } from "./AdminItemShedule.vue?vue&type=template&id=6299409d"
import script from "./AdminItemShedule.vue?vue&type=script&lang=js"
export * from "./AdminItemShedule.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__